export enum ActivityFees {
  PreparationAndAnimationFees = 'preparationAndAnimationFees',
  SubsistenceFees = 'subsistenceFees',
  TravelFees = 'travelFees',
  TeachingMaterialFees = 'teachingMaterialFees',
  RoomRentalFees = 'roomRentalFees',
  EquipmentRentalFees = 'equipmentRentalFees',
}
